import { pxToRem } from '../common/utils/utils';

export const themeOptions = {
  palette: {
    primary: {
      main: '#5A5F72',
    },
    secondary: {
      main: '#66669A',
    },
    error: {
      main: '#EB7070',
    },
    warning: {
      main: '#EBD070',
    },
    logo: {
      main: '#566385',
    },
    hyperLink: {
      main: '#6A93D1',
    },
    disabled: {
      default: '#F9FBFF',
    },
    accent: {
      main: '#333',
    },
    success: {
      main: '#499C47',
    },
    border: {
      divider: '#EBF0F8',
    },
    mobile: {
      listItemHeader: '#676B7C',
    },
    text: {
      primary: '#5A5F72',
      secondary: '#9699B5',
      disabled: '#CFD8E8',
      warning: '#E08B67',
    },
    link: {
      default: '#333333',
      hover: '#6366F1',
      active: '#6366F1',
      disabled: '#CFD8E8',
    },
    button: {
      default: '#6366F1',
      hover: '#7B7DFF',
      active: '#4D4FAF',
      disabled: '#CFD8E8',
    },
    tags: {
      error: '#DC2626',
      success: '#059669',
      waiting: '#E5EEFF',
      draft: '#FED7AA',
      warningBg: '#FFF5E6',
      warningText: '#E08B67',
    },
    mobileTags: {
      error: '#FFDDDD',
      success: '#D7F8E0',
    },
  },
  shape: {
    borderRadius: 8,
  },
  props: {
    MuiButtonBase: {
      disableRipple: true,
    },
  },
  typography: {
    fontFamily: " 'SB Sans Text'",
    fontSize: 15,
    h1: {
      fontWeight: 800,
      fontSize: pxToRem(26, true),
      lineHeight: pxToRem(35, true),
    },
    h2: {
      fontWeight: 700,
      fontSize: pxToRem(22, true),
      lineHeight: pxToRem(29, true),
    },
    h3: {
      fontWeight: 700,
      fontSize: pxToRem(19, true),
      lineHeight: pxToRem(26, true),
    },
    h4: {
      fontWeight: 400,
      fontSize: pxToRem(19, true),
      lineHeight: pxToRem(26, true),
    },
    h5: {
      fontWeight: 700,
      fontSize: pxToRem(17, true),
      lineHeight: pxToRem(23, true),
    },
    h6: {
      fontWeight: 600,
      fontSize: pxToRem(17, true),
      lineHeight: pxToRem(26, true),
    },
    subtitle1: {
      fontWeight: 700,
      fontSize: pxToRem(15, true),
      lineHeight: pxToRem(20, true),
    },
    subtitle2: {
      fontWeight: 500,
      fontSize: pxToRem(14, true),
      lineHeight: pxToRem(18, true),
      color: '#999DA2',
    },
    body1: {
      fontWeight: 500,
      fontSize: pxToRem(14, true),
      lineHeight: pxToRem(18, true),
      // color: '#999DA2 !important',
    },
    body2: {
      fontWeight: 400,
      fontSize: pxToRem(13, true),
      lineHeight: pxToRem(18, true),
    },
    caption: {
      fontWeight: 400,
      fontSize: pxToRem(11, true),
      lineHeight: pxToRem(15, true),
      letterSpacing: 0.5,
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 767,
      md: 1024,
      lg: 1280,
      xl: 1920,
    },
  },
};
